<div class="confirm-modal p-4">
  <h3> {{data?.title}} </h3>
  @if (data?.status) {
    <img alt="message svg" [src]="isSuccess ? 'assets/svg/success.svg' : 'assets/svg/error.svg'" />
  }
  @if (data?.message) {
    <span class="dialog-header">
      {{data?.message}}
    </span>
  }
  @for (item of data?.list; track item) {
    <ul>
      <li>{{item}}</li>
    </ul>
  }
  <div class="buttons d-flex justify-content-center">
    <button [ngClass]="{'radius-button': data?.onlyConfirm}" class="round-button button-text main m-2 mt-5"
    mat-flat-button color="primary" (click)="answer(true)">{{data?.onlyConfirm ? 'OK': 'Yes'}}</button>
    @if (!data?.onlyConfirm) {
      <button class="round-button button-text m-2 mt-5" mat-stroked-button
      (click)="answer(false)">No</button>
    }
  </div>
</div>
